var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoTutorials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.79522,
    y: -2.79522,
    width: 18.5904,
    height: 18.5904
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.4px)",
      clipPath: "url(#bgblur_0_9331_5901_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.79522,
    d: "M13 6.5C13 10.0899 10.0899 13 6.5 13C2.91005 13 0 10.0899 0 6.5C0 2.9107 2.91005 0 6.5 0C10.0899 0 13 2.9107 13 6.5Z",
    fill: "#FF3949",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.42677,
    y: -2.42677,
    width: 25.802,
    height: 25.802
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.58px)",
      clipPath: "url(#bgblur_1_9331_5901_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 5.16041,
    d: "M10.4741 2.84131C14.6898 2.84131 18.1078 6.25921 18.1079 10.4741C18.1079 14.6899 14.6899 18.1079 10.4741 18.1079C6.25845 18.1078 2.84131 14.6898 2.84131 10.4741C2.84142 6.25928 6.25852 2.84142 10.4741 2.84131Z",
    fill: "#FF3949",
    fillOpacity: 0.1,
    stroke: "url(#paint0_linear_9331_5901)",
    strokeWidth: 0.215017,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.99154,
    y: 4.2391,
    width: 11.7183,
    height: 12.471
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.61px)",
      clipPath: "url(#bgblur_2_9331_5901_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9331_5901)",
    "data-figma-bg-blur-radius": 3.22526
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4847 10.4783C13.4847 10.6684 13.4249 10.8594 13.3051 11.0123C13.2827 11.0423 13.1779 11.1659 13.0956 11.2464L13.0507 11.2902C12.4222 11.9567 10.8582 12.9589 10.0651 13.28C10.0651 13.2873 9.59364 13.4783 9.36915 13.4848H9.33922C8.99501 13.4848 8.67325 13.2954 8.50863 12.9881C8.41883 12.8191 8.33652 12.329 8.32904 12.3224C8.26169 11.8828 8.2168 11.2098 8.2168 10.4709C8.2168 9.69625 8.26169 8.99325 8.34401 8.56165C8.34401 8.55433 8.42632 8.15931 8.4787 8.02763C8.56101 7.83817 8.71066 7.6765 8.89774 7.57408C9.04739 7.50166 9.20453 7.46436 9.36915 7.46436C9.54126 7.4724 9.86302 7.5814 9.99023 7.63261C10.8283 7.95448 12.4296 9.00788 13.0432 9.65163C13.148 9.75404 13.2602 9.87913 13.2902 9.90766C13.4174 10.0686 13.4847 10.2661 13.4847 10.4783Z",
    fill: "url(#paint1_linear_9331_5901)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36719 7.50732C9.44766 7.51109 9.567 7.53916 9.68457 7.57373L9.97461 7.67236C10.3893 7.83161 10.9962 8.17367 11.5771 8.55713C12.158 8.94056 12.7083 9.36289 13.0117 9.68115L13.0127 9.68213C13.0643 9.73254 13.1183 9.78895 13.1631 9.83643C13.2046 9.88052 13.2405 9.91908 13.2578 9.93604C13.3779 10.0887 13.4414 10.2761 13.4414 10.478C13.4414 10.6594 13.3848 10.8411 13.2715 10.9858L13.2705 10.9868C13.2489 11.0155 13.1459 11.1366 13.0654 11.2153L13.0205 11.2593L13.0195 11.2612C12.7087 11.5907 12.1635 12.005 11.5957 12.3784C11.028 12.7517 10.4416 13.0807 10.0488 13.2397L10.0225 13.2515V13.2534C10.01 13.2588 9.99261 13.2656 9.97168 13.2739C9.92466 13.2927 9.85925 13.3178 9.78711 13.3423C9.64098 13.3918 9.47304 13.4387 9.36816 13.4419H9.33887C9.01066 13.4418 8.70396 13.261 8.54688 12.9683C8.50518 12.8898 8.46272 12.7303 8.42969 12.5845C8.41348 12.5129 8.3998 12.4464 8.38965 12.397C8.38459 12.3723 8.38017 12.3511 8.37695 12.3364C8.3754 12.3293 8.37428 12.3226 8.37305 12.3179C8.37249 12.3158 8.37185 12.3133 8.37109 12.311L8.37012 12.3091C8.3038 11.8722 8.25978 11.2048 8.25977 10.4712C8.25977 9.89063 8.28498 9.35151 8.33203 8.93799L8.38672 8.56982V8.56689C8.3868 8.56639 8.38743 8.56542 8.3877 8.56396C8.38826 8.56093 8.38849 8.55608 8.38965 8.55029C8.39196 8.53876 8.39518 8.52232 8.39941 8.50244C8.4079 8.46257 8.42011 8.40879 8.43359 8.35107C8.46077 8.23475 8.49381 8.10703 8.51855 8.04443C8.59662 7.86501 8.73817 7.71079 8.91602 7.61279C9.05947 7.54337 9.21003 7.50762 9.36719 7.50732Z",
    stroke: "url(#paint2_linear_9331_5901)",
    strokeWidth: 0.0860068
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9331_5901_clip_path",
    transform: "translate(2.79522 2.79522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13 10.0899 10.0899 13 6.5 13C2.91005 13 0 10.0899 0 6.5C0 2.9107 2.91005 0 6.5 0C10.0899 0 13 2.9107 13 6.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9331_5901_clip_path",
    transform: "translate(2.42677 2.42677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4741 2.84131C14.6898 2.84131 18.1078 6.25921 18.1079 10.4741C18.1079 14.6899 14.6899 18.1079 10.4741 18.1079C6.25845 18.1078 2.84131 14.6898 2.84131 10.4741C2.84142 6.25928 6.25852 2.84142 10.4741 2.84131Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9331_5901",
    x: 4.99154,
    y: 4.2391,
    width: 11.7183,
    height: 12.471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.07509,
    dy: 1.07509
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07509
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9331_5901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9331_5901",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9331_5901_clip_path",
    transform: "translate(-4.99154 -4.2391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4847 10.4783C13.4847 10.6684 13.4249 10.8594 13.3051 11.0123C13.2827 11.0423 13.1779 11.1659 13.0956 11.2464L13.0507 11.2902C12.4222 11.9567 10.8582 12.9589 10.0651 13.28C10.0651 13.2873 9.59364 13.4783 9.36915 13.4848H9.33922C8.99501 13.4848 8.67325 13.2954 8.50863 12.9881C8.41883 12.8191 8.33652 12.329 8.32904 12.3224C8.26169 11.8828 8.2168 11.2098 8.2168 10.4709C8.2168 9.69625 8.26169 8.99325 8.34401 8.56165C8.34401 8.55433 8.42632 8.15931 8.4787 8.02763C8.56101 7.83817 8.71066 7.6765 8.89774 7.57408C9.04739 7.50166 9.20453 7.46436 9.36915 7.46436C9.54126 7.4724 9.86302 7.5814 9.99023 7.63261C10.8283 7.95448 12.4296 9.00788 13.0432 9.65163C13.148 9.75404 13.2602 9.87913 13.2902 9.90766C13.4174 10.0686 13.4847 10.2661 13.4847 10.4783Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9331_5901",
    x1: 5.34464,
    y1: 4.70221,
    x2: 14.9457,
    y2: 16.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9331_5901",
    x1: 13.1112,
    y1: 8.55153,
    x2: 7.2418,
    y2: 8.71898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9331_5901",
    x1: 9.05536,
    y1: 8.16575,
    x2: 12.9713,
    y2: 12.4095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTutorials);
export default __webpack_public_path__ + "static/media/videoTutorials.70f9b867bf98fcad1c42108fd318a801.svg";
export { ForwardRef as ReactComponent };